
import {
	Component,
	Vue
} from 'vue-property-decorator';
import PageFooter from '@/components/page-footer.vue';
import PickerDate from '@/components/picker-date.vue';
import Dialog from '@/components/dialog.vue';
import UploadImg from '@/components/upload-img.vue';
import RadioButton from '@/components/radio-button.vue';
import {
	providerSelectItem
} from '@/api/supplier';
import {
	productSendlist,
	productSendsendOrderDetailImport,
	productSendsentCollectList,
	currentEmployeeRoleInfo,
	productSendcopySendInfo,
	ordersyncOrderToProviderConfig
} from '@/api/order'
import {
	getSearchDate,
	nextDay
} from "@/utils/index"
import {
	handleClipboard
} from '@/utils/clipboard'
import axios from 'axios'
@Component({
	name: '',
	components: {
		PageFooter,
		PickerDate,
		'slz-dialog': Dialog,
		UploadImg,
		RadioButton,
	}
})

export default class ProductList extends Vue {
	private radioType = 1
	private radioList = [{
		value: 1,
		label: "商品发货统计"
	},
	{
		value: 2,
		label: "商品发货进度汇总"
	},
	]
	private keywords = ''
	private suppliers = null
	private filterTime = [getSearchDate(2, false, -7)[0], getSearchDate(2, false, -1)[0]].join('/')
	private keywords2 = ''
	private suppliers2 = null
	private filterTime2 = [getSearchDate(2, false, -3)[0], getSearchDate(2, false, -1)[0]].join('/')
	private supplierslist: any = []

	private tablelist: any = []
	private headlist: any = []
	private result: any = {}
	private tableloading = false
	private pageNo = 1;
	private pageSize = 10;
	private total = 0;

	private rowmsg: any = {}
	private showExportOrder = false
	private exportFilterTime = []
	private currentId = 0
	private exportLoading = false
	private exporttype = 1

	private showImportExel = false
	private importloading = false
	private importUrl = ''
	private importName = ''

	private ProductIdList: any = []
	private iscombined = false

	private tablelist2: any = []
	private tableloading2 = false;

	private permissions = true; //产品发货管理是否部分权限

	private copymsg: any = {}
	private abnormalurl = ''

	private isLookAbnormalExpress = false;

	private synchronousTime = ''


	private mounted() {
		this.getSupplierList()
		this.gettablelist()
		this.getRole();
		this.gettime();
	}

	activated() {
		this.getRole();
		this.gettablelist()
		this.gettime();
	}

	private async gettime() {
		try {
			let res = await axios.get('/pc/order/syncOrderToProviderConfig')
			// console.log(res.data.Result)
			if (res.data.Result.SyncOrderToProviderEndTime) {
				this.synchronousTime = nextDay(res.data.Result.SyncOrderToProviderEndTime, -1)
			}
		} finally {
			//
		}
	}
	private async savesynchronous() {
		if (!this.synchronousTime) {
			this.$message.error('请选择日期')
			return
		}
		try {
			let data = {
				SyncOrderToProviderEndTime: nextDay(JSON.parse(JSON.stringify(this.synchronousTime)), 1)
			}
			let res: any = await ordersyncOrderToProviderConfig(data)
			if (res.IsSuccess) {
				this.$message.success('操作成功')
			}
		} finally {
			//
		}
	}
	private async abnormallogistics(row) {
		// console.log(location.origin)
		await this.getcopymsg(row)
		// console.log(location.origin)
		window.open(this.abnormalurl)
	}
	async getcopymsg(row) {
		try {
			this.tableloading = true
			let data: any = {
				ProductId: row.ProductId,
				ProviderId: row.ProviderId
			}
			if (this.filterTime) {
				var dt = this.filterTime.split('/');
				data.StartTime = dt[0]
				data.EndTime = nextDay(dt[1], 1)
			}
			let res = await productSendcopySendInfo(data)
			if (res.IsSuccess) {
				this.copymsg = res.Result
				this.abnormalurl = location.origin + '/abnormalLogistics.html' + '?Param=' + this.copymsg.Param
				// this.abnormalurl = 'http://10.0.0.59/abnormalLogistics.html' + '?Param=' + this.copymsg.Param
			}
		} finally {
			this.tableloading = false
		}
	}
	private async copytext(row) {
		this.rowmsg = row
		await this.getcopymsg(row)
		let copy = document.getElementById('copy') as any
		copy.click()
	}
	private deliverystatus(event) {
		handleClipboard(this.copymsg.Info + this.abnormalurl, event)
	}

	/**
	 * 获取权限
	 */
	private async getRole() {
		let res: any = await currentEmployeeRoleInfo({})
		if (res.IsSuccess) {
			this.permissions = res.Result.DeliveryManagementIsPartPermissions;
		}
	}

	private async exportabnormal(e) {
		let row = await e
		let url = location.origin + '/pc/order/productSend/expressAbnormalOrderDetailExport'
		url += '?ProductId=' + (row.ProductId || '');
		url += '&ProviderId=' + (row.ProviderId || '');
		if (this.filterTime) {
			var dt = this.filterTime.split('/');
			url += '&StartTime=' + (dt[0] || '');
			url += '&EndTime=' + (dt[1] ? nextDay(dt[1], 1) : '');
		}
		window.open(url);
	}
	private changetype(e) {
		this.pageNo = 1
		if (e == 1) {
			this.gettablelist()
		} else {
			this.gettablelist2()
		}
	}

	private async gettablelist2() {
		try {
			this.tableloading2 = true
			let data: any = {
				Keywords: this.keywords2,
				ProviderId: this.suppliers2,
				Skip: (this.pageNo - 1) * this.pageSize,
				Take: this.pageSize,
				IsLookAbnormalExpress: this.isLookAbnormalExpress
			}
			if (this.filterTime2) {
				var dt = this.filterTime2.split('/');
				data.StartTime = dt[0]
				data.EndTime = nextDay(dt[1], 1)
			}
			let res: any = await productSendsentCollectList(data)
			if (res.IsSuccess) {
				this.tablelist2 = res.Result.Results
				this.total = res.Result.Total
			}
		} finally {
			this.tableloading2 = false
		}
	}
	private handleImport(id: number) {
		this.showImportExel = true;
		this.currentId = id;
	}
	private async handleConfirmImport() {
		if (!this.importUrl) {
			this.$message({
				type: 'warning',
				message: '请上传发货单'
			});
			return;
		}
		try {
			this.importloading = true
			const res: any = await productSendsendOrderDetailImport({
				ProductId: this.currentId,
				ExcelFileName: this.importName,
				ExcelFilePath: this.importUrl
			});
			if (res.IsSuccess) {
				this.$message({
					type: 'success',
					message: '导入成功'
				});
				this.handleCloseImport();
				this.$alert('处理中，稍后可刷新页面获取最新的产品发货数据', '导入成功', {
					confirmButtonText: '关闭',
					callback: action => {
						this.doSearch()
					}
				});
			}
		} catch (err) {
			console.log(err);
			this.handleCloseImport();
			this.$message({
				type: 'error',
				message: '导入失败'
			})
		} finally {
			this.importloading = false
		}
	}
	private uploadSuc(list: any, name: string) {
		this.importUrl = list[0];
		this.importName = name;
	}
	private handleExport(row, type, num) {
		this.showExportOrder = true
		this.exportFilterTime = this.filterTime.split('/')

		// this.currentId = id;
		// console.log(id)

		//num 1合计导出2单个导出
		this.iscombined = num == 1
		this.rowmsg = row
		this.ProductIdList = num == 1 ? this.result.ProductIdList : [row.ProductId]
		// console.log(this.ProductIdList)
		this.exporttype = type
	}
	private handleCloseImport() {
		this.currentId = 0
		this.showExportOrder = false
		this.exportFilterTime = []
		this.showImportExel = false
		this.importUrl = ''
		this.importName = ''
	}
	//合计导出
	private async exportFile2(e) {

		let row = await e
		let url = location.origin + '/pc/order/productSend/sentOrderDetailExport'
		url += '?Keywords=' + encodeURIComponent(this.keywords);
		url += '&ProductId=' + (row.ProductId || '');
		url += '&ProviderId=' + (this.suppliers || '');
		if (this.filterTime) {
			var dt = this.filterTime.split('/');
			url += '&StartTime=' + (dt[0] || '');
			url += '&EndTime=' + (dt[1] ? nextDay(dt[1], 1) : '');
		}
		// console.log(url)
		// return
		window.open(url)
	}
	//单个导出
	private async exportFile() {
		let url = location.origin + '/pc/order/productSend/sendOrderDetailExport'
		url += '?Keywords=' + (this.iscombined ? this.keywords : '');
		url += '&ProviderId=' + (this.iscombined ? (this.suppliers || '') : this.rowmsg.ProviderId);
		url += '&ProductId=' + (this.iscombined ? '' : this.rowmsg.ProductId);
		if (this.exportFilterTime) {
			url += '&StartTime=' + (this.exportFilterTime[0] || '');
			url += '&EndTime=' + (this.exportFilterTime[1] ? nextDay(this.exportFilterTime[1], 1) : '');
		}
		// console.log(url)
		window.open(url);
	}
	private lookdetail(row) {
		// console.log(this.filterTime,1)
		this.$router.push({
			path: 'deliverymanagement_detail',
			query: {
				Id: row.ProductId,
				ProviderId: row.ProviderId,
				filterTime: this.filterTime
			}
		})
	}
	private changePage(e) {
		if (!this.maxdays() && this.radioType == 1) return
		this.pageNo = e
		if (this.radioType == 1) {
			this.gettablelist()
		} else {
			this.gettablelist2()
		}
	}
	// 获取供应商列表
	private async getSupplierList() {
		try {
			const res: any = await providerSelectItem({});
			this.supplierslist = res.Result.map(v => {
				return {
					value: v.Id,
					label: v.ProviderName
				}
			})
		} catch (e) {
			console.log('supplierList ===>', e);
		}
	}
	private maxdays() {
		if (this.filterTime && this.radioType == 1) {
			let params: any = {}
			var dt = this.filterTime.split('/');
			params.StartTime = new Date(dt[0]).getTime()
			params.EndTime = new Date(dt[1]).getTime()
			let days = (params.EndTime - params.StartTime) / 1000 / 60 / 60 / 24
			// console.log(days)
			if (days > 30) {
				this.$message.error('跨度不允许超过31天')
				return false
			}
		}
		return true
	}
	private doSearch() {
		if (!this.maxdays() && this.radioType == 1) return
		this.pageNo = 1
		if (this.radioType == 1) {
			this.gettablelist()
		} else {
			this.gettablelist2()
		}
	}
	private clearSearch() {
		if (this.radioType == 1) {
			this.keywords = ''
			this.suppliers = null
			this.filterTime = [getSearchDate(2, false, -7)[0], getSearchDate(2, false, -1)[0]].join('/')
		} else {
			this.keywords2 = ''
			this.suppliers2 = null
			this.filterTime2 = [getSearchDate(2, false, -3)[0], getSearchDate(2, false, -1)[0]].join('/')
		}
		this.doSearch()
	}
	private exportExcel() {
		if (!this.maxdays() && this.radioType == 1) return
		let url = location.origin + (this.radioType == 1 ? '/pc/order/productSend/list' :
			'/pc/order/productSend/sentCollectList')
		if (this.radioType == 1) {
			url += '?Keywords=' + (this.keywords || '')
			url += '&ProviderId=' + (this.suppliers || '')
			url += '&IsLookAbnormalExpress=' + this.isLookAbnormalExpress
			if (this.filterTime) {
				let dt = this.filterTime.split('/');
				url += '&AddStartTime=' + (dt[0] || '');
				url += '&AddEndTime=' + (dt[1] ? nextDay(dt[1], 1) : '');
			}
		} else {
			url += '?Keywords=' + (this.keywords2 || '')
			url += '&ProviderId=' + (this.suppliers2 || '')
			if (this.filterTime2) {
				let dt = this.filterTime2.split('/');
				url += '&StartTime=' + (dt[0] || '');
				url += '&EndTime=' + (dt[1] ? nextDay(dt[1], 1) : '');
			}
		}

		// console.log(url)
		window.open(url);
	}
	private async gettablelist() {
		try {
			this.tableloading = true
			let data: any = {
				Keywords: this.keywords,
				ProviderId: this.suppliers,
				Skip: (this.pageNo - 1) * this.pageSize,
				Take: this.pageSize,
				IsLookAbnormalExpress: this.isLookAbnormalExpress
			}
			if (this.filterTime) {
				var dt = this.filterTime.split('/');
				data.AddStartTime = dt[0]
				data.AddEndTime = nextDay(dt[1], 1)
			}
			let res: any = await productSendlist(data)
			if (res.IsSuccess) {
				this.tablelist = res.Result.Results
				this.headlist = [res.Result.Head]
				this.result = res.Result
				this.total = res.Result.Total
			}
		} finally {
			this.tableloading = false
		}
	}
}
